export const chooseProject = {
  projectSelection: 'Projektwahl',
  section2Title: 'Unsere beliebtesten Projekte',
}
